import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'month'
})
/**
 * 將 yyyyMMdd 格式（例如：20260521）只取 MM（例如：05）
 */
export class MonthPipe implements PipeTransform {
  transform(value: string): string {
    if (!/^\d{8}$/.test(value)) {
    return '';
    }
    if (!value || value.length !== 8) return '';
    return value.slice(4, 6); // 取 MM
  }
}